export var isRemoveComponent = function (schema) {
    var _a;
    return ((_a = schema['x-component']) === null || _a === void 0 ? void 0 : _a.includes('CnArrayTableRemove')) > -1;
};
